require('./tenantDialog.style.scss');

class TenantDialogController {
    constructor(
        $scope,
        $filter,
        crudService,
        storageService,
        sharedPersistenceService,
        principalService,
        logoutService,
        $window
    ) {
        this.$scope = $scope;
        this.$filter = $filter;
        this.crudService = crudService;
        this.storageService = storageService;
        this.principalService = principalService;
        this.$window = $window;
        this.logoutService = logoutService;
        this.REST_ENDPOINTS = sharedPersistenceService.getRestEndpoints();
        this.showModal = false;
        this.title = this.$filter('translate')('login.form.signin.info.tenants.modal.title');
    }

    $onInit() {
        this.actionButtons = [
            {
                type: 'submit',
                title: this.$filter('translate')('login.form.signin.info.tenants.modal.signIn'),
                action: () => {
                    this.loginWithTenant();
                },
                isDisabled: () => {
                    if (!this.tenant || (this.tenant && this.tenant.length === 0)) {
                        return true;
                    } else {
                        return false;
                    }
                },
                id: 'session-expiration-continue',
            },
        ];
    }

    onOpen() {
        this.tenantList = this.tenantList.map((tenant) => {
            return { value: tenant.tenantId, label: tenant.displayName, subLabel: 'UID: ' + tenant.tenantId };
        });
    }

    loginWithTenant() {
        this.onTenantSelect({ tenant: this.tenant });
    }

    onClose() {
        this.showModal = false;
    }
}

TenantDialogController.$inject = [
    '$scope',
    '$filter',
    'crudService',
    'storageService',
    'sharedPersistenceService',
    'principalService',
    'logoutService',
    '$window',
];

const tenantDialogComponent = {
    controller: TenantDialogController,
    template: require('./tenantDialog.template.html'),
    bindings: {
        showModal: '=',
        onTenantSelect: '&?',
        tenantList: '=?',
        onClose: '&?',
    },
};

module.exports = tenantDialogComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/login/dialogs/tenantDialog/tenantDialog.component.js